import React, { Component } from "react";
import BreadcrumbCustomer from "../breadcrumb";
import {  Form, Upload, Select, Button,Radio,message,Tooltip, Divider} from 'antd';
import { InboxOutlined, UploadOutlined } from '@ant-design/icons';
 import {dbFields}  from '../../model/user/column';
import { route } from "../../routes/routes";
import storage from "../../utils/storage";
import { configs } from "../../config/config";


export const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 14,
    },
};

export const tailLayout = {
    wrapperCol: {
      offset: 8,
      span: 16,
    },
};

const Option = Select.Option;
const ModeType = [
    { type: 1, name: 'FIRMWARE' },
];
class ExportHistory extends Component {
    formRef = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            data: {
                type: null,
                name:null
            }
        }
    };
    componentWillUnmount(){
        if (!storage.check(configs.cache.tokenKey)) {
            this.props.history.push("/")
        }
    }
    

    render() {
        const { data } = this.state;
        return (
            <>
                <BreadcrumbCustomer first='ExportHistory' second='Create' />
                <Tooltip title="用户须知" defaultVisible={true} >
                    <span>Tooltip will show on mouse enterTooltip will show on mouse enter.Tooltip will show on mouse enter.Tooltip will show on mouse enter.Tooltip will show on mouse enter.Tooltip will show on mouse enter.Tooltip will show on mouse enter.Tooltip will show on mouse enter.Tooltip will show on mouse enter.Tooltip will show on mouse enter.Tooltip will show on mouse enter..</span>
                </Tooltip>
                <Divider />
                <Form
                    {...layout}
                    initialValues={{
                        remember: true,
                    }}
                    >
                    <Form.Item
                            name="upload"
                            label="Upload"
                            valuePropName="fileList"
                            extra="please input the file"
                        >
                            <Upload name="logo" action="/upload.do" listType="picture">
                            <Button icon={<UploadOutlined />}>Click to upload</Button>
                            </Upload>
                        </Form.Item>

                        <Form.Item
                            wrapperCol={{
                                span: 12,
                                offset: 6,
                              }}
                        >
                            <Button type="primary" htmlType="submit">
                                Submit
                            </Button>
                        </Form.Item>    

                </Form>    
            
            </>
        );
    }
}

export default ExportHistory;